export default __webpack_public_path__ + "static/media/da.025c1210.svg";